import { makeStyles } from 'tss-react/mui';

import { SpacingParams } from './FilePreview.types';

export const useStyles = makeStyles<{
  mt: SpacingParams;
  mb: SpacingParams;
}>()(({ breakpoints, spacing, tokens }, { mb, mt }) => ({
  documentCursor: {
    cursor: 'pointer',
  },

  square: {
    paddingTop: '100%',
  },

  dialogPaper: {
    '&, &.MuiDialog-paperFullScreen.MuiDialog-paperScrollBody': {
      [breakpoints.up('xs')]: {
        marginTop: spacing(5.2), // TODO - fix нет в токенах
        marginBottom: spacing(6.4), // TODO - fix нет в токенах
      },

      [breakpoints.up('sm')]: {
        marginTop: 0,
      },

      [breakpoints.up('md')]: {
        marginTop: tokens.spacing['32'],
        marginBottom: spacing(9.8), // TODO - нет в токенах
      },
    },

    '&.MuiDialog-paperFullScreen': {
      [breakpoints.up('xs')]: {
        height: 'max-content',
      },

      [breakpoints.up('sm')]: {
        height: 'max-content',
      },
    },
  },

  paper: {
    '&, &.MuiDialog-paperFullScreen.MuiDialog-paperScrollBody': {
      [breakpoints.up('xs')]: {
        marginTop: spacing(mt.xs ?? 0),
        marginBottom: spacing(mb.xs ?? 0),
      },

      [breakpoints.up('sm')]: {
        marginTop: spacing(mt.sm ?? 0),
        marginBottom: spacing(mb.sm ?? 0),
      },

      [breakpoints.up('md')]: {
        marginTop: spacing(mt.md ?? 0),
        marginBottom: spacing(mb.md ?? 0),
      },
    },

    '&.MuiDialog-paperFullScreen': {
      [breakpoints.up('xs')]: {
        maxHeight: `calc(100% - ${
          (mt.xs ? mt.xs * 10 : 0) + (mb.xs ? mb.xs * 10 : 0)
        }px)`,
      },

      [breakpoints.up('sm')]: {
        maxHeight: `calc(100% - ${
          (mt.sm ? mt.sm * 10 : 0) + (mb.sm ? mb.sm * 10 : 0)
        }px)`,
      },

      [breakpoints.up('md')]: {
        maxHeight: `calc(100% - ${
          (mt.md ? mt.md * 10 : 0) + (mb.md ? mb.md * 10 : 0)
        }px)`,
      },
    },
  },

  errorFile: {
    display: 'flex',
    width: '100%',
    height: '100%',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: tokens.spacing['16'],
  },
}));
